import { Component, Input, OnInit } from '@angular/core';
import { FilteringService } from 'app/services/filtering.service';
import { LegFiJwtService } from 'app/services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from 'app/services/auth/jwt-legfi-claims.model';
import moment from 'moment-timezone';
import { OrganizationService } from 'app/services/organization/organization.service';
import { Organization } from 'app/models/entities/organization';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { Moment } from 'moment';

@UntilDestroy()
@Component({
    selector: 'report-filter-single-date-range',
    templateUrl: './single-date-range.component.html',
    styleUrls: ['./single-date-range.component.scss'],
})
export class SingleDateRangeComponent implements OnInit
{
    @Input()
    public filters: {
        startDate: Moment;
        endDate: Moment;
    } = null;

    @Input()
    public defaultToFiscalYear: boolean = false;

    @Input() public defaultToThisMonth: boolean = false;

    @Input()
    public container: FilterContainerComponent;

    public isAdmin: boolean = false;

    public _filteringService: FilteringService;

    public fiscalStartMonth: number = 1;

    private jwt: JwtLegFiClaims;

    private months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    constructor(
            _filteringService: FilteringService,
            private _organizationService: OrganizationService,
    ) {
        this._filteringService = _filteringService;
        this.jwt = LegFiJwtService.read();
    }

    ngOnInit() {
        this.container.register(this);
        let passedInFilters = true;
        if (this.filters === null) {
            passedInFilters = false;
            this.filters = {
                startDate: moment().startOf('year'),
                endDate: moment().endOf('year'),
            };
        }

        this.isAdmin = this.jwt.admin || this.jwt.superUser;
        this._organizationService
                .getOrganizationById(null, ['profile'])
                .pipe(untilDestroyed(this))
                .subscribe((org: Organization) => {
                    this.fiscalStartMonth = org.profile.fiscalPeriodStart;
                    if (!passedInFilters && this.defaultToFiscalYear) {
                        this._filteringService.setThisFiscalYearDatePicker(
                                this.filters,
                                this.fiscalStartMonth,
                        );
                    }
                    if (this.defaultToThisMonth) {
                        this._filteringService.setThisMonthDatePicker(
                                this.filters,
                        );
                    }
                    this.container.notifyReady(this);
                });
    }

    public parentReloadReport() {
        this.container.reloadReport();
    }

    public getCurrentFiscalYearDisplay(): string {
        const now = new Date();
        const startMonth = this.fiscalStartMonth - 1;
        let startYear = now.getFullYear() - 1;

        let endMonth = this.fiscalStartMonth - 2;

        if (now.getMonth() + 1 >= this.fiscalStartMonth) {
            startYear = now.getFullYear();
        }

        let endYear = startYear + 1;
        if (this.fiscalStartMonth === 1) {
            endMonth = 11;
            endYear = startYear;
        }

        return (
                this.months[startMonth] +
                ' ' +
                startYear +
                ' - ' +
                this.months[endMonth] +
                ' ' +
                endYear
        );
    }
}
